(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scooth-size-guide"] && !Shopify.designMode) return;
  try {
    /**
   * Marks the row matching the shopper's currently selected size.
   *
   * Enhancement only: the table is fully usable without this, so every failure
   * path here is a silent no-op rather than a thrown error.
   *
   * Matching is on the first token of each value, uppercased, because option
   * values in this catalogue carry their measurements inline — "S (1.5-4kg)",
   * "M 50x40cm", "S - 60x40cm" — while the guide rows are labelled "S" and "M".
   * Comparing whole strings would match almost nothing.
   */
  if (!customElements.get('scooth-size-guide')) {
    class ScoothSizeGuide extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-size-key]'));
        if (!this.rows.length) return;

        // Scope to the enclosing section rather than a theme-specific class, so
        // this keeps working if the surrounding markup is restructured.
        this.scope = this.closest('[id^="shopify-section"]') || document.body;
        this.handleChange = this.handleChange.bind(this);
        this.scope.addEventListener('change', this.handleChange);

        // Defer the first pass: the variant picker may still be settling its
        // checked state when this element connects.
        requestAnimationFrame(() => this.sync());
      }

      disconnectedCallback() {
        if (this.scope) this.scope.removeEventListener('change', this.handleChange);
      }

      handleChange() {
        this.sync();
      }

      static token(value) {
        const parts = String(value == null ? '' : value)
          .trim()
          .toUpperCase()
          .split(/[^A-Z0-9.]+/);
        return parts[0] || '';
      }

      selectedTokens() {
        const tokens = new Set();
        const inputs = this.scope.querySelectorAll('input[type="radio"]:checked, select');

        inputs.forEach((input) => {
          if (this.contains(input)) return;
          const token = ScoothSizeGuide.token(input.value);
          if (token) tokens.add(token);
        });

        return tokens;
      }

      sync() {
        let tokens;
        try {
          tokens = this.selectedTokens();
        } catch (error) {
          return;
        }

        this.rows.forEach((row) => {
          const key = ScoothSizeGuide.token(row.dataset.sizeKey);
          const isSelected = key !== '' && tokens.has(key);

          row.classList.toggle('is-selected', isSelected);

          const flag = row.querySelector('[data-selected-flag]');
          if (flag) flag.hidden = !isSelected;
        });
      }
    }

    customElements.define('scooth-size-guide', ScoothSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
